import React from "react";

import { useStateContext } from "../../contexts/ContextProvider";

import { Form } from "react-bootstrap";

const GrievencesSortModal = ({
  checkedTimeSort,
  setCheckedTimeSort,
  setStatus,
  applySort,
  resetFilter,
  validated,
  statusChecked,
  setStatusChecked
}) => {
  const { sortBy } = useStateContext();

  

  const handleChecked = (e) => {
    if (e.target.checked) {
      setCheckedTimeSort(e.target.value);
    }
  };

  const handleChecked2 = (e) => {
    const { name, checked, value } = e.target;
    setStatusChecked((prevState) => ({
      ...prevState,
      [name]: checked,
    }));

    // console.log(name, checked, value)

    if (checked) {
      setStatus((prevColumns) => [...prevColumns, value]);
    } else {
      setStatus((prevColumns) => prevColumns.filter((col) => col !== value));
    }
  };

  return (
    <>
      <div
        className={`${sortBy ? "sortByModal visible" : "sortByModal hidden"}`}
      >
        <div className="filter-flex">
          <Form noValidate validated={validated} onSubmit={applySort}>
            <div className="sort-list">
              <div className="heading mb-3">
                <span>Sort</span>
              </div>
              <div className="csort">
                <span>Time</span>
                <ul>
                  <li>
                    <div className="sort-flex">
                      <span>Show Oldest First</span>
                      <label className="checkbox-container">
                        <input
                          type="radio"
                          value="oldest"
                          checked={checkedTimeSort === "oldest"}
                          onChange={handleChecked}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="sort-flex">
                      <span>Show Latest First</span>
                      <label className="checkbox-container">
                        <input
                          type="radio"
                          value="latest"
                          checked={checkedTimeSort === "latest"}
                          onChange={handleChecked}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </li>
                </ul>
                <hr />
                <span>Status</span>
                <div className="statusFilter-flex visible">
                  <div className="sort-flex">
                    <span className="status-filter new">New</span>
                    <label className="checkbox-container">
                      <input
                        type="checkbox"
                        name="new"
                        value="1"
                        checked={statusChecked["new"] || false}
                        onChange={handleChecked2}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                  <div className="sort-flex ">
                    <span className="status-filter inprocess">In-Process</span>
                    <label className="checkbox-container">
                      <input
                        type="checkbox"
                        name="inprocess"
                        value="2"
                        checked={statusChecked["inprocess"] || false}
                        onChange={handleChecked2}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                  <div className="sort-flex ">
                    <span className="status-filter resolved">Resolved</span>
                    <label className="checkbox-container">
                      <input
                        type="checkbox"
                        name="resolved"
                        value="3"
                        checked={statusChecked["resolved"] || false}
                        onChange={handleChecked2}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="sort-action">
              <button className="btn btn-reset" onClick={resetFilter}>
                Reset
              </button>
              <button className="btn btn-apply">Apply</button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default GrievencesSortModal;
